/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.WorkshopCloneSettings = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The WorkshopCloneSettings model module.
   * @module model/WorkshopCloneSettings
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>WorkshopCloneSettings</code>.
   * @alias module:model/WorkshopCloneSettings
   * @class
   */
  var exports = function() {
    var _this = this;











  };

  /**
   * Constructs a <code>WorkshopCloneSettings</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/WorkshopCloneSettings} obj Optional instance to populate.
   * @return {module:model/WorkshopCloneSettings} The populated <code>WorkshopCloneSettings</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('SourceWorkshopID')) {
        obj['SourceWorkshopID'] = ApiClient.convertToType(data['SourceWorkshopID'], 'Integer');
      }
      if (data.hasOwnProperty('UseTemplateCompany')) {
        obj['UseTemplateCompany'] = ApiClient.convertToType(data['UseTemplateCompany'], 'Boolean');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('CloneParticipants')) {
        obj['CloneParticipants'] = ApiClient.convertToType(data['CloneParticipants'], 'Boolean');
      }
      if (data.hasOwnProperty('CloneComments')) {
        obj['CloneComments'] = ApiClient.convertToType(data['CloneComments'], 'Boolean');
      }
      if (data.hasOwnProperty('CloneCategories')) {
        obj['CloneCategories'] = ApiClient.convertToType(data['CloneCategories'], 'Boolean');
      }
      if (data.hasOwnProperty('CloneItems')) {
        obj['CloneItems'] = ApiClient.convertToType(data['CloneItems'], 'Boolean');
      }
      if (data.hasOwnProperty('CloneRatings')) {
        obj['CloneRatings'] = ApiClient.convertToType(data['CloneRatings'], 'Boolean');
      }
      if (data.hasOwnProperty('TargetCompanyIDs')) {
        obj['TargetCompanyIDs'] = ApiClient.convertToType(data['TargetCompanyIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('ParticipantIDs')) {
        obj['ParticipantIDs'] = ApiClient.convertToType(data['ParticipantIDs'], ['Integer']);
      }
    }
    return obj;
  }

  /**
   * @member {Integer} SourceWorkshopID
   * @default 0
   */
  exports.prototype['SourceWorkshopID'] = 0;
  /**
   * @member {Boolean} UseTemplateCompany
   * @default false
   */
  exports.prototype['UseTemplateCompany'] = false;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Boolean} CloneParticipants
   * @default false
   */
  exports.prototype['CloneParticipants'] = false;
  /**
   * @member {Boolean} CloneComments
   * @default false
   */
  exports.prototype['CloneComments'] = false;
  /**
   * @member {Boolean} CloneCategories
   * @default false
   */
  exports.prototype['CloneCategories'] = false;
  /**
   * @member {Boolean} CloneItems
   * @default false
   */
  exports.prototype['CloneItems'] = false;
  /**
   * @member {Boolean} CloneRatings
   * @default false
   */
  exports.prototype['CloneRatings'] = false;
  /**
   * @member {Array.<Integer>} TargetCompanyIDs
   */
  exports.prototype['TargetCompanyIDs'] = undefined;
  /**
   * @member {Array.<Integer>} ParticipantIDs
   */
  exports.prototype['ParticipantIDs'] = undefined;



  return exports;
}));


